// The Text block's paragraph, which is rich text.
//
// A paragraph written before the editor existed has only `text`, typed
// into a textarea and shown with its line breaks kept. It is read as
// HTML the first time it is opened — a blank line starts a new
// paragraph, a single line break stays a line break — and is stored as
// HTML from the first edit on. Nothing is migrated in the database: a
// block nobody opens renders exactly as it did.

function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function textToHtml(text) {
    const t = String(text || '').replace(/\r\n?/g, '\n');
    if (!t.trim()) return '';
    return t.split(/\n{2,}/)
        .map((para) => `<p>${escapeHtml(para).replace(/\n/g, '<br>')}</p>`)
        .join('');
}

// What the editor and the page show for a paragraph item.
export function paragraphHtml(item) {
    if (typeof item?.html === 'string' && item.html !== '') return item.html;
    return textToHtml(item?.text);
}

// A paragraph with html is rich; one without is the old plain text.
export function isRich(item) {
    return typeof item?.html === 'string' && item.html !== '';
}

// The plain reading of the html, one line per paragraph or list item.
export function richToText(html) {
    if (typeof document === 'undefined') return String(html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    // DOMParser, not innerHTML on a live element: a parsed document is
    // inert, so an <img onerror> pasted into a paragraph cannot run here.
    const marked = String(html || '').replace(/<\/(p|li|h[1-6]|blockquote)>/gi, '$&\n').replace(/<br\s*\/?>/gi, '\n');
    const doc = new DOMParser().parseFromString(marked, 'text/html');
    return (doc.body.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
}
